export const mustMatchTo =
  (matchToId, message = "Values don't match") =>
  (value, formValues) =>
    value === formValues[matchToId] ? undefined : message;

export default mustMatchTo;
